import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

// Firebase Config
var firebaseConfig = {
  apiKey: "AIzaSyBBTkfa4AzFZ-DzTqkFbVW_s5PDeb_R7tg",
  authDomain: "igagent.firebaseapp.com",
  projectId: "igagent",
  storageBucket: "igagent.appspot.com",
  messagingSenderId: "869245435695",
  appId: "1:869245435695:web:45e3f7d8cb6e0d4e032bda",
  measurementId: "G-K2DD5KVCE2",
};

// Initializing Firebase App
firebase.initializeApp(firebaseConfig);

export const GoogleFirebase = firebase;

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();
